import React from 'react';
import { useNavigate } from 'react-router-dom';
import StripeService from '../../services/StripeService';
import { fetchAuthSession } from 'aws-amplify/auth';
import { userAppContext } from '../../Context/Context';
import { useAcademicApplication } from '../../hooks/useAcademicApplication';

export async function redirectToAdvancedPlan() {
  const priceId = process.env.REACT_APP_STRIPE_ADVANCED_PRICE_ID;

  if (!priceId) {
    console.warn('No priceId defined for Professional plan');
    alert('This plan is not available for purchase at the moment. Please contact support.');
    return;
  }

  try {
    let customerEmail;
    try {
      const session = await fetchAuthSession();
      customerEmail = session.tokens?.idToken?.payload?.email;
    } catch (error) {
      console.warn('Could not get user email:', error);
    }

    await StripeService.redirectToCheckout({
      title: 'Professional',
      priceId,
      quantity: 1,
      customerEmail,
    });
  } catch (error) {
    console.error('Error creating checkout session:', error);
    alert('There was an error processing your request. Please try again or contact support.');
  }
}

function AdvancedPlanCard() {
  const navigate = useNavigate();
  const { isAuthenticated, user } = userAppContext();
  const { activeCampaignLists } = useAcademicApplication(user?.email, isAuthenticated);

  // Check if user can see prices (must be in lists 21, 12, or 15)
  const canSeePrices =
    !isAuthenticated ||
    (activeCampaignLists &&
      (activeCampaignLists.includes('21') ||
        activeCampaignLists.includes('12') ||
        activeCampaignLists.includes('15')));

  return (
    <div className="PricingCard-ac">
      <header>
        <p className="card-title">Advanced</p>
        <p className="card-price">API Access</p>
        {canSeePrices ? (
          <p className="card-price">1,999 EUR / year</p>
        ) : (
          <p className="card-price" style={{ opacity: 0.8 }}>
            Contact us for pricing
          </p>
        )}
      </header>
      <button className="btn-gradient-pink" onClick={() => redirectToAdvancedPlan()}>
        Upgrade
      </button>
      <button className="btn-gradient-pink" onClick={() => navigate('/academic-plans')}>
        + info
      </button>
    </div>
  );
}

function AdvancedPlanOnly() {
  return (
    <div className="PricingApp">
      <div className="app-container">
        <div className="pricing-cards p-3 flex-row gap-4">
          <AdvancedPlanCard />
        </div>
      </div>
    </div>
  );
}

export default AdvancedPlanOnly;
